import React from 'react';

import { getThemeClass } from '../../tools/textTools';
import ContentfulImage from '../Common/ContentfulImage';
import { PrimaryLink } from '../Common/Links';
import { HeadingCta } from '../Generic/HeadingCtas';
import PageSection from '../PageSections/PageSection';
import * as styles from './GradientToCtaHeader.module.scss';

const GradientToCtaHeader = ({ section }) => {
  const theme = getThemeClass(section.colorTheme?.themeName);
  const ctaTheme = getThemeClass(section.ctaBanner?.colorTheme?.themeName);
  const { title, description, ctaLabel, url } = section?.ctaBanner ?? {};

  return (
    <>
      <PageSection
        backgroundImage={section.backgroundImage}
        className={[styles.section, theme].join(' ')}
        style={{ paddingTop: 0 }}
        isTopSection={true}
        wide
        data-analytics-section={'gradient-to-cta-header'}
      >
        <div className={styles.content}>
          <div className={styles.headline}>
            <div className={styles.pillEyebrow}>
              <ContentfulImage imageFragment={section.eyebrowIcon} className={styles.eyebrowIcon} lazy={false} />
              <div className={styles.pillEyebrowText}>
                <span className={styles.main}>{section.eyebrowText}</span>
                <span className={styles.sub}>{section.eyebrowSubtext}</span>
              </div>
            </div>
            <h1>{section.headline}</h1>
          </div>
          <ContentfulImage
            className={styles.mainImage}
            imageFragment={section.mainImage}
            gatsbyImageData={section.mainImage.gatsbyImageData}
          />
        </div>
        <div className={[ctaTheme, styles.cta].join(' ')}>
          <div className={styles.copy}>
            <span className={styles.eyebrow}>{title}</span>
            <h4>{description?.description}</h4>
          </div>
          <div className={styles.button}>
            <HeadingCta cta={{ url: url, linkText: ctaLabel, theme: ctaTheme }} />
          </div>
        </div>
      </PageSection>
    </>
  );
};

export default GradientToCtaHeader;
